/* ============================================================
   FLOOF 5 .. the only script the new layout adds. Deferred, no dependencies.

   It does a few small things and NOTHING on the page depends on it to be
   visible. With this file dead: banners show their still image, rails still
   scroll, every link and form still works, the menu and filter buttons are
   the only things that go quiet.

     [data-f5-open="ID"]   opens <dialog id="ID"> as a modal
     [data-f5-close]       closes the dialog it sits in
     [data-f5-count]       the bag badge, kept in step with the cart
     video[data-f5-video]  loads and plays only while on screen
     [data-f5-pdp]         the product page: variants, photos, the buy bar
     #F5Search             the search panel's live suggestions
     [data-f5-wish]        the wishlist hearts, the header count, the saved page
     [data-f5-recent]      the Recently viewed row

   ES5 on purpose. Instagram's in-app browser is modern, but old Android
   WebViews are exactly the devices this store has struggled on.
   ============================================================ */
(function () {
  'use strict';

  /* anything that only works with this script (the hearts) is hidden by CSS
     until this class exists */
  document.documentElement.classList.add('f5-js');

  /* ---------------- dialogs ---------------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-f5-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-f5-open'));
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        /* one dialog at a time: an opener inside a dialog closes its own */
        var from = opener.closest('dialog');
        if (from && from !== d && from.open) from.close();
        if (!d.open) d.showModal();
      }
      return;
    }

    /* the bag icon in the menu's top row: floof-cart.js opens the bag, and the
       menu steps aside, so closing the bag lands on the page, not the menu */
    var bag = t.closest('[data-cart-open]');
    if (bag) {
      var menu = bag.closest('dialog.f5-dlg--left');
      if (menu && menu.open) menu.close();
    }

    var closer = t.closest('[data-f5-close]');
    if (closer) {
      var host = closer.closest('dialog');
      if (host) host.close();
      return;
    }

    /* a click that lands on the dialog element itself is a click on the
       backdrop, because the panel inside covers everything else */
    if (t.tagName === 'DIALOG' && t.classList.contains('f5-dlg') && t.open) t.close();
  });

  /* ---------------- the bag badge ----------------
     floof-cart.js owns every cart mutation and knows nothing about this
     header. So instead of the two files talking, this watches fetch: any
     request to /cart/add|change|update|clear is followed by one small
     /cart.js read. It catches every mutation however it happens. */

  function paintCount(n) {
    var els = document.querySelectorAll('[data-f5-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].hidden = n === 0;
    }
    var bags = document.querySelectorAll('[data-f5-bag]');
    for (var j = 0; j < bags.length; j++) {
      bags[j].setAttribute('aria-label', n === 1 ? 'Bag, 1 item' : 'Bag, ' + n + ' items');
    }
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () {
            nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) { paintCount(c.item_count); })
              .catch(function () {});
          }, function () {});
        }
      } catch (err) {}
      return p;
    };
  }

  /* ---------------- videos ----------------
     No video file is requested until the banner is near the screen, AND not
     before the page has finished loading and the phone has a quiet moment:
     the hero film is 2 to 3 MB, and requested with the page it competed with
     the poster (the LCP), the font and the stylesheet on a phone connection
     (measured 2026-10-03). The poster is a complete banner on its own, so
     the film arriving a beat later changes nothing anyone can see. The
     source is chosen once, by viewport, so a phone never downloads the
     desktop file. Nothing autoplays for reduced motion, Data Saver or a
     2G/3G connection (Chrome reports it; Safari does not, so iPhones play). */

  var vids = document.querySelectorAll('video[data-f5-video]');
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection;
  var saver = !!(conn && (conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '')));

  /* runs fn once the page has loaded and the main thread is idle */
  function settled(fn) {
    var go = function () {
      if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 300);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  if (vids.length && !calm && !saver && 'IntersectionObserver' in window) settled(function () {
    var phone = matchMedia('(max-width: 749px)');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) {
          if (!v.getAttribute('src')) {
            var src = phone.matches ? (v.getAttribute('data-src-m') || v.getAttribute('data-src-d')) : (v.getAttribute('data-src-d') || v.getAttribute('data-src-m'));
            if (!src) continue;
            v.setAttribute('src', src);
          }
          var play = v.play();
          if (play && play.catch) play.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { rootMargin: '200px 0px', threshold: 0 });

    for (var k = 0; k < vids.length; k++) {
      vids[k].addEventListener('playing', function () { this.classList.add('is-on'); });
      io.observe(vids[k]);
    }
  });

  /* ---------------- product page ----------------
     Money is NEVER formatted here. Every string swapped in below (prices,
     compare-at prices, the offer ladder) was built by Liquid's money filter
     into the variants blob. This only picks which string to show.

     With this file dead the page is still complete for the variant Shopify
     selected: the price, the button and the ladder are all server-rendered.
     Only switching variant goes quiet, and the form still posts. */

  var pdp = document.querySelector('[data-f5-pdp]');
  if (pdp) initPdp(pdp);

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function initPdp(root) {
    var variants = [];
    var blob = root.querySelector('[data-f5-variants]');
    if (blob) {
      try { variants = JSON.parse(blob.textContent); } catch (e) {}
    }

    var labels = {
      add: root.getAttribute('data-add') || 'Add to bag',
      out: root.getAttribute('data-out') || 'Sold out',
      none: root.getAttribute('data-none') || 'Unavailable'
    };

    var vid = root.querySelector('[data-f5-vid]');
    var sets = root.querySelectorAll('[data-f5-opt]');
    var radios = root.querySelectorAll('[data-f5-val]');
    var track = root.querySelector('[data-f5-track]');
    var dots = root.querySelectorAll('[data-f5-dot]');
    var single = window.matchMedia ? matchMedia('(max-width: 989px)') : null;

    /* ---- photos 2 onwards ----
       They ship with their srcset parked in data-srcset, so the first photo
       (the LCP) has the connection to itself. Handed over after load, or the
       moment someone reaches for the gallery, whichever is first. */
    var promoted = false;
    function promote() {
      if (promoted) return;
      promoted = true;
      each(root.querySelectorAll('img[data-srcset]'), function (img) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      });
    }
    if (document.readyState === 'complete') setTimeout(promote, 200);
    else window.addEventListener('load', function () { setTimeout(promote, 200); });
    setTimeout(promote, 5000);
    if (track) {
      track.addEventListener('touchstart', promote, { passive: true });
      track.addEventListener('pointerdown', promote);
    }

    /* ---- position dots ---- */
    function paintDots() {
      if (!track || !dots.length) return;
      var w = track.clientWidth || 1;
      var n = Math.round(track.scrollLeft / w);
      each(dots, function (d, i) { d.classList.toggle('is-on', i === n); });
    }
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        promote();
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paintDots(); });
      }, { passive: true });
    }

    /* A variant's photo moves to the FRONT of the strip, on phone and tablet
       only. On desktop every photo is already on screen in the grid, and
       reordering it under the cursor would just look like a glitch. */
    function show(mediaId) {
      if (!track || !mediaId || (single && !single.matches)) return;
      each(track.querySelectorAll('[data-media]'), function (li) {
        li.style.order = li.getAttribute('data-media') === String(mediaId) ? '-1' : '';
      });
      track.scrollLeft = 0;
      promote();
      paintDots();
    }

    function picked() {
      var out = [];
      each(sets, function (set) {
        var on = set.querySelector('input:checked');
        out.push(on ? on.value : null);
      });
      return out;
    }

    function fits(vr, want) {
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== null && vr.options[j] !== want[j]) return false;
      }
      return true;
    }

    function match(want) {
      for (var i = 0; i < variants.length; i++) if (fits(variants[i], want)) return variants[i];
      return null;
    }

    /* contextual: can `value` at `pos` still reach an AVAILABLE variant,
       given what is picked for the other options? */
    function canHave(pos, value) {
      var want = picked();
      want[pos] = value;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available && fits(variants[i], want)) return true;
      }
      return false;
    }

    function setAll(sel, fn) { each(root.querySelectorAll(sel), fn); }

    function onPick(first) {
      each(radios, function (r) {
        var set = r.closest('[data-f5-opt]');
        var label = r.parentNode;
        if (!set || !label) return;
        var pos = parseInt(set.getAttribute('data-f5-opt'), 10);
        label.classList.toggle('is-out', !canHave(pos, r.value));
        label.classList.toggle('is-on', r.checked);
      });

      each(sets, function (set) {
        var on = set.querySelector('input:checked');
        var out = set.querySelector('[data-f5-optval]');
        if (on && out) out.textContent = on.value;
      });

      var v = match(picked());

      if (!v) {
        setAll('[data-f5-add]', function (b) { b.disabled = true; });
        setAll('[data-f5-label]', function (l) { l.textContent = labels.none; });
        return;
      }

      if (vid) vid.value = v.id;
      setAll('[data-f5-price]', function (p) { p.textContent = v.price; });
      setAll('[data-f5-was]', function (w) {
        if (v.compare) { w.textContent = v.compare; w.hidden = false; }
        else w.hidden = true;
      });
      setAll('[data-f5-add]', function (b) { b.disabled = !v.available; });
      setAll('[data-f5-label]', function (l) { l.textContent = v.available ? labels.add : labels.out; });

      if (v.tiers) {
        setAll('[data-f5-tier]', function (row, i) {
          var t = v.tiers[i];
          if (!t) return;
          var was = row.querySelector('[data-f5-tier-was]');
          var now = row.querySelector('[data-f5-tier-now]');
          if (was) was.textContent = t[0];
          if (now) now.textContent = t[1];
        });
      }

      if (!first) {
        show(v.media);
        /* replaceState: picking a colour is not a navigation, and Back should
           not walk through every swatch tried */
        if (window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u.toString());
          } catch (e) {}
        }
      }
    }

    each(radios, function (r) {
      r.addEventListener('change', function () { onPick(false); });
    });
    if (radios.length) onPick(true);

    /* ---- the buy bar ----
       Up only while the real button is off screen, so two identical buttons
       are never visible together. No observer: it simply never shows. */
    var bar = root.querySelector('[data-f5-bar]');
    var main = root.querySelector('[data-f5-main]');
    if (bar && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var up = !entries[0].isIntersecting;
        bar.classList.toggle('is-up', up);
        document.documentElement.classList.toggle('f5-bar-up', up);
      }, { threshold: 0 }).observe(main);
    }
  }

  /* ---------------- this browser's lists ----------------
     The wishlist (f5-wish) and Recently viewed (f5-rv) are product handles in
     localStorage. Every read and write is guarded: a private window or a
     blocked store just means empty lists, never an error. */

  function loadList(key) {
    try {
      var v = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) { return []; }
  }

  function saveList(key, list) {
    try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  /* ---------------- cards by handle ----------------
     A product known only by its handle is drawn by asking Shopify to render
     sections/f5-card-fragment.liquid for it, so the card, its price and its
     badge are server-made. Parsed in a <template>, where images do not load,
     so `sizes` could be changed before anything downloads. It is left as the
     fragment rendered it: the grid's sizes, scaled by f5-card for its default
     square frame, which is right for the saved page and a touch generous for
     the narrower Recently viewed cards. */

  var cardCache = {};

  function cardHtml(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=f5-card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return cardCache[handle];
  }

  function fillCards(list, handles, sizes, itemClass, done) {
    Promise.all(handles.map(cardHtml)).then(function (htmls) {
      var n = 0;
      each(htmls, function (h) {
        if (!h) return;
        var t = document.createElement('template');
        t.innerHTML = h;
        var art = t.content.querySelector('.f5-card');
        if (!art) return;
        if (sizes) each(art.querySelectorAll('img[sizes]'), function (img) { img.setAttribute('sizes', sizes); });
        var li = document.createElement('li');
        if (itemClass) li.className = itemClass;
        li.appendChild(art);
        list.appendChild(li);
        n++;
      });
      paintHearts();
      done(n);
    });
  }

  /* ---------------- wishlist ---------------- */

  function paintHearts() {
    var list = loadList('f5-wish');
    each(document.querySelectorAll('[data-f5-wish]'), function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-f5-wish')) > -1 ? 'true' : 'false');
    });
    each(document.querySelectorAll('[data-f5-wish-count]'), function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  var wl = document.querySelector('[data-f5-wishlist]');

  function paintWishlist() {
    if (!wl) return;
    var n = wl.querySelectorAll('[data-f5-list] > li').length;
    var count = wl.querySelector('[data-f5-wl-count]');
    var empty = wl.querySelector('[data-f5-wl-empty]');
    if (count) count.textContent = n ? n : '';
    if (empty) empty.hidden = n > 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('[data-f5-wish]') : null;
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-f5-wish');
    var list = loadList('f5-wish');
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1);
    else list.unshift(h);
    saveList('f5-wish', list.slice(0, 60));
    paintHearts();
    /* on the saved page, letting go of a heart lets go of the card */
    if (i > -1 && wl && wl.contains(b)) {
      var li = b.closest('li');
      if (li) li.parentNode.removeChild(li);
      paintWishlist();
    }
  });

  paintHearts();

  if (wl) {
    var saved = loadList('f5-wish');
    var grid = wl.querySelector('[data-f5-list]');
    if (saved.length && grid) {
      fillCards(grid, saved, null, '', paintWishlist);
    } else {
      paintWishlist();
    }
  }

  /* ---------------- recently viewed ----------------
     The product page records itself AFTER the row has read the list, so the
     row never offers the page you are on. */

  var here = pdp ? pdp.getAttribute('data-handle') : '';
  var rv = document.querySelector('[data-f5-recent]');

  if (rv) {
    var skip = rv.getAttribute('data-f5-recent') || here;
    var max = parseInt(rv.getAttribute('data-max'), 10) || 8;
    var seen = [];
    each(loadList('f5-rv'), function (h) { if (h !== skip && seen.length < max) seen.push(h); });
    var track = rv.querySelector('[data-f5-list]');
    if (seen.length && track) {
      fillCards(track, seen, null, 'f5-rail__item', function (n) {
        if (!n) return;
        rv.hidden = false;
      });
    }
  }

  if (here) {
    var past = [here];
    each(loadList('f5-rv'), function (h) { if (h !== here && past.length < 16) past.push(h); });
    saveList('f5-rv', past);
  }

  /* ---------------- search suggestions ----------------
     Typing in the search panel asks Shopify's predictive search for
     sections/f5-predictive.liquid and drops it under the field. A newer
     keystroke cancels the older request, and a late answer for an old term is
     thrown away. The form still submits to /search either way. */

  var sd = document.getElementById('F5Search');
  var sq = sd ? sd.querySelector('[data-f5-q]') : null;

  if (sd && sq) {
    var res = sd.querySelector('[data-f5-results]');
    var links = sd.querySelector('[data-f5-sd-links]');
    var base = sd.getAttribute('data-f5-suggest') || '/search/suggest';
    var timer = null;
    var lastTerm = '';
    var ctrl = null;

    sq.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var term = sq.value.replace(/^\s+|\s+$/g, '');
        if (term === lastTerm) return;
        lastTerm = term;
        if (term.length < 2) {
          res.innerHTML = '';
          if (links) links.hidden = false;
          return;
        }
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(base + '?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=product&resources%5Blimit%5D=6&section_id=f5-predictive', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            if (term !== lastTerm) return;
            var t = document.createElement('template');
            t.innerHTML = h;
            var inner = t.content.querySelector('.shopify-section') || t.content;
            res.innerHTML = '';
            while (inner.firstChild) res.appendChild(inner.firstChild);
            if (links) links.hidden = res.children.length > 0;
            paintHearts();
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------- reels ----------------
     The row (sections/f5-reels.liquid): the card nearest the middle is
     .is-active and the only one playing, muted, and only while the row is on
     screen. Nothing previews under reduced motion or Data Saver; the posters
     are the row then. The arrows under it step one card.

     THE LOOP. With more than one reel the Liquid writes the cards three times
     (data-sets="3"). The row starts in the middle set; when a scroll settles in
     a copy, the row jumps, instantly and with the scale transition off, by one
     set to the same card in the real set, and the preview carries on from the
     same moment in that card's video. Settling is `scrollend` where it exists
     and a short pause in scroll events elsewhere.

     The player: a <dialog> of vertical slides that snap. ONE <video> is moved
     into the slide being watched and its file swapped, because Safari grants
     sound per element: the tap that opened the player unlocks this element,
     and it keeps playing with sound from reel to reel. If a browser still
     refuses sound without a fresh tap, it plays muted and the button brings
     the sound back. Without showModal a card opens the reel on Instagram. */

  each(document.querySelectorAll('[data-f5-reels]'), initReels);

  function initReels(root) {
    var track = root.querySelector('[data-f5-reels-track]');
    if (!track) return;
    var cards = track.querySelectorAll('[data-f5-reel]');
    if (!cards.length) return;
    /* the page carries the real set only; buildLoop() adds the copies */
    var sets = 1;
    var per = cards.length;
    var loop = track.hasAttribute('data-loop') && per > 1;
    var dlg = root.querySelector('[data-f5-rp]');
    var list = dlg ? dlg.querySelector('[data-f5-rp-list]') : null;
    var tpl = dlg ? dlg.querySelector('[data-f5-rp-tpl]') : null;
    var slides = dlg ? dlg.querySelectorAll('[data-f5-rp-slide]') : [];
    var pv = dlg ? dlg.querySelector('[data-f5-rp-vid]') : null;
    var home = pv ? pv.parentNode : null;
    var bar = dlg ? dlg.querySelector('[data-f5-rp-progress]') : null;
    var muteBtn = dlg ? dlg.querySelector('[data-f5-rp-mute]') : null;
    var quiet = calm || saver;
    var active = 0;
    var seen = false;
    var current = -1;
    each(cards, function (c, k) { if (c.classList.contains('is-active')) active = k; });

    function preview(i, on) {
      var v = cards[i] ? cards[i].querySelector('video') : null;
      if (!v) return;
      if (!on) { if (!v.paused) v.pause(); return; }
      if (quiet || !seen || (dlg && dlg.open)) return;
      if (!v.getAttribute('src')) {
        var src = v.getAttribute('data-src');
        if (!src) return;
        v.setAttribute('src', src);
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function setActive(i) {
      if (i === active) return;
      preview(active, false);
      cards[active].classList.remove('is-active');
      active = i;
      cards[active].classList.add('is-active');
      preview(active, true);
    }

    function onPlaying() { this.classList.add('is-on'); }
    each(cards, function (c) {
      var v = c.querySelector('video');
      if (v) v.addEventListener('playing', onPlaying);
    });

    /* THE LOOP'S COPIES are made here, not written by Liquid: one set either
       side of the real one, built when the row comes near the screen or is
       first touched, so they are never part of the page at load (see
       sections/f5-reels.liquid). A copy is aria-hidden, takes no focus,
       carries no theme editor outline and has no video source of its own.
       The scroll position is moved by the width just added in front, under
       .is-jumping, so nothing on screen moves. */
    function copyCard(c) {
      var n = c.cloneNode(true);
      n.classList.remove('is-active');
      n.setAttribute('aria-hidden', 'true');
      n.removeAttribute('data-shopify-editor-block');
      each(n.querySelectorAll('a, button, input, select, textarea'), function (el) { el.setAttribute('tabindex', '-1'); });
      each(n.querySelectorAll('video'), function (v) {
        v.removeAttribute('src');
        v.classList.remove('is-on');
        v.addEventListener('playing', onPlaying);
      });
      return n;
    }

    function buildLoop() {
      if (!loop || sets === 3) return;
      var real = Array.prototype.slice.call(cards);
      var before = real[active].offsetLeft;
      var head = document.createDocumentFragment();
      var tail = document.createDocumentFragment();
      each(real, function (c) { head.appendChild(copyCard(c)); tail.appendChild(copyCard(c)); });
      track.classList.add('is-jumping');
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
      cards = track.querySelectorAll('[data-f5-reel]');
      sets = 3;
      active += per;
      track.scrollLeft += cards[active].offsetLeft - before;
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    }

    var frame = 0;
    function nearest() {
      frame = 0;
      var r = track.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var best = active;
      var gap = Infinity;
      each(cards, function (c, k) {
        var b = c.getBoundingClientRect();
        var d = Math.abs(b.left + b.width / 2 - mid);
        if (d < gap) { gap = d; best = k; }
      });
      setActive(best);
    }
    track.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame ? requestAnimationFrame(nearest) : setTimeout(nearest, 50);
    }, { passive: true });

    function go(i, instant) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var c = cards[i];
      var left = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
      if (instant || calm || !track.scrollTo) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
      setActive(i);
    }

    /* the loop: back into the real set once a scroll has settled in a copy */
    function settle() {
      if (sets < 3) return;
      var shift = active < per ? per : active >= per * 2 ? -per : 0;
      if (!shift) return;
      var from = cards[active];
      var to = cards[active + shift];
      var oldV = from.querySelector('video');
      var t = oldV && !oldV.paused ? oldV.currentTime : 0;
      track.classList.add('is-jumping');
      track.scrollLeft += to.offsetLeft - from.offsetLeft;
      setActive(active + shift);
      var newV = to.querySelector('video');
      if (newV && t) {
        var seek = function () {
          newV.removeEventListener('loadedmetadata', seek);
          try { newV.currentTime = t; } catch (err) {}
        };
        if (newV.readyState >= 1) seek(); else newV.addEventListener('loadedmetadata', seek);
      }
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    }

    var rest = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(rest);
      rest = setTimeout(settle, 160);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(rest); settle(); });

    /* a row wide enough for three cards starts on its middle reel, so both
       sides are full, like the reference */
    var start = 0;
    if (track.clientWidth >= cards[0].offsetWidth * 3) start = Math.floor((per - 1) / 2);
    track.classList.add('is-jumping');
    go(start, true);
    void track.offsetWidth;
    track.classList.remove('is-jumping');

    /* a rotated phone or a resized window changes the card width: re-centre */
    var sizing = 0;
    window.addEventListener('resize', function () {
      clearTimeout(sizing);
      sizing = setTimeout(function () { go(active, true); }, 150);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        seen = es[es.length - 1].isIntersecting;
        preview(active, seen);
      }, { threshold: 0.3 }).observe(track);
    }

    /* the copies: near the screen, or the first touch, whichever comes first.
       If the observer never fires (an in-app browser reporting no height),
       the first touch still builds them before the row can run out. */
    if (loop) {
      each(['pointerdown', 'touchstart', 'wheel', 'focusin'], function (type) {
        track.addEventListener(type, buildLoop, { once: true, passive: true });
      });
      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (es) {
          if (!es[es.length - 1].isIntersecting) return;
          near.disconnect();
          buildLoop();
        }, { rootMargin: '0px 0px 600px 0px' });
        near.observe(track);
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var opener = t.closest('[data-f5-reel-open]');
      if (opener) { open(+opener.getAttribute('data-f5-reel-open')); return; }
      var stepper = t.closest('[data-f5-reels-step]');
      if (stepper) { buildLoop(); go(active + (+stepper.getAttribute('data-f5-reels-step'))); }
    });

    if (!dlg || !pv || !list || typeof dlg.showModal !== 'function') {
      open = function (i) {
        var b = track.querySelector('[data-f5-reel-open="' + i + '"][data-ig]');
        if (b) window.open(b.getAttribute('data-ig'), '_blank', 'noopener');
      };
      return;
    }

    /* the player's slides wait in a <template> until the first reel is
       opened; the hearts in them are painted once they exist */
    function buildSlides() {
      if (!tpl || slides.length) return;
      list.appendChild(tpl.content);
      slides = list.querySelectorAll('[data-f5-rp-slide]');
      paintHearts();
    }

    function paintMute() {
      if (!muteBtn) return;
      muteBtn.setAttribute('aria-pressed', pv.muted ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', pv.muted ? 'Sound on' : 'Mute');
    }

    function play() {
      var p = pv.play();
      if (p && p.catch) p.catch(function () {
        pv.muted = true;
        paintMute();
        var q = pv.play();
        if (q && q.catch) q.catch(function () {});
      });
    }

    function show(i) {
      if (i === current || !slides[i]) return;
      current = i;
      var slide = slides[i];
      each(slides, function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.remove('is-paused');
      });
      pv.classList.remove('is-on');
      var frame = slide.querySelector('.f5-rp__frame') || slide;
      frame.insertBefore(pv, frame.querySelector('.f5-grain') || frame.querySelector('.f5-rp__paused'));
      pv.src = slide.getAttribute('data-src');
      if (bar) bar.style.transform = 'scaleX(0)';
      play();
    }

    function open(i) {
      buildSlides();
      each(cards, function (c, k) { preview(k, false); });
      dlg.showModal();
      pv.muted = false;
      paintMute();
      current = -1;
      list.scrollTop = slides[i] ? slides[i].offsetTop : 0;
      show(i);
    }

    /* Share sends the product page: the phone's own share sheet where there
       is one, otherwise the link is copied and the label says so a moment */
    function share(btn) {
      var url = btn.getAttribute('data-url');
      if (navigator.share) {
        navigator.share({ title: btn.getAttribute('data-title') || '', url: url }).catch(function () {});
        return;
      }
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(function () {
        var label = btn.parentNode.querySelector('[data-f5-rp-share-label]');
        var copied = dlg.getAttribute('data-copied');
        if (!label || !copied) return;
        var was = label.textContent;
        label.textContent = copied;
        setTimeout(function () { label.textContent = was; }, 1600);
      }).catch(function () {});
    }

    function step(d) {
      var i = Math.max(0, Math.min(slides.length - 1, current + d));
      if (!list.scrollTo || calm) list.scrollTop = slides[i].offsetTop;
      else list.scrollTo({ top: slides[i].offsetTop, behavior: 'smooth' });
    }

    var pframe = 0;
    list.addEventListener('scroll', function () {
      if (pframe) return;
      var settle = function () {
        pframe = 0;
        var i = Math.round(list.scrollTop / (list.clientHeight || 1));
        if (i !== current) show(i);
      };
      pframe = window.requestAnimationFrame ? requestAnimationFrame(settle) : setTimeout(settle, 50);
    }, { passive: true });

    pv.addEventListener('playing', function () { pv.classList.add('is-on'); });
    pv.addEventListener('timeupdate', function () {
      if (bar && pv.duration) bar.style.transform = 'scaleX(' + (pv.currentTime / pv.duration) + ')';
    });

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('[data-f5-rp-mute]')) {
        pv.muted = !pv.muted;
        paintMute();
        if (pv.paused) play();
        return;
      }
      var stepper = t.closest('[data-f5-rp-step]');
      if (stepper) { step(+stepper.getAttribute('data-f5-rp-step')); return; }
      var sharer = t.closest('[data-f5-rp-share]');
      if (sharer) { share(sharer); return; }
      if (t.closest('a, button, form, input')) return;
      var slide = t.closest('[data-f5-rp-slide]');
      if (!slide || !slide.classList.contains('is-active')) return;
      if (pv.paused) { play(); slide.classList.remove('is-paused'); }
      else { pv.pause(); slide.classList.add('is-paused'); }
    });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); step(-1); }
    });

    /* adding to the bag opens the bag over the player: stop the sound first */
    dlg.addEventListener('submit', function () {
      pv.pause();
      if (slides[current]) slides[current].classList.add('is-paused');
    });

    dlg.addEventListener('close', function () {
      pv.pause();
      pv.removeAttribute('src');
      pv.load();
      pv.classList.remove('is-on');
      home.appendChild(pv);
      current = -1;
      preview(active, true);
    });
  }

  /* ---------------- footer columns ----------------
     <details> on a phone, open columns on desktop. Opening them here rather
     than duplicating the markup keeps one copy of every link. */

  if (window.matchMedia && matchMedia('(min-width: 990px)').matches) {
    var cols = document.querySelectorAll('.f5-ft__col');
    for (var c = 0; c < cols.length; c++) cols[c].open = true;
  }

  /* ---------------- the footer reveal ----------------
     floof5.css draws it (.f5-reveal: the footer's wrapper sticks to the
     bottom, behind the page). This only decides whether it may: the whole
     footer has to fit on the screen with room to spare, or its top could
     never be seen. Checked again on resize (a phone turning, a toolbar
     folding away) and whenever a footer accordion opens or shuts. The smaller
     of the two viewport heights is used, and a zero from either, which some
     in-app browsers report, turns the reveal off rather than on. */

  var ftWrap = document.querySelector('.f5-ftwrap');
  if (ftWrap) {
    var fitFrame = 0;
    var fitFooter = function () {
      fitFrame = 0;
      var vh = Math.min(window.innerHeight || 0, document.documentElement.clientHeight || 0);
      var fh = ftWrap.offsetHeight;
      var on = vh > 0 && fh > 0 && fh <= vh - 64;
      document.documentElement.classList.toggle('f5-reveal', on);
    };
    var askFit = function () {
      if (!fitFrame) fitFrame = window.requestAnimationFrame ? requestAnimationFrame(fitFooter) : setTimeout(fitFooter, 16);
    };
    fitFooter();
    window.addEventListener('resize', askFit);
    /* toggle does not bubble, so it is caught on the way down */
    ftWrap.addEventListener('toggle', askFit, true);

    /* A STUCK FOOTER COUNTS AS ON SCREEN EVEN WHILE THE PAGE COVERS IT, so the
       browser never scrolls to it by itself: not for the #f5-nl the newsletter
       form returns to after a sign-up, and not for a footer link reached with
       Tab. Both are sent to the end of the page, where the footer is open. */
    /* ONLY NEAR THE END. The wrapper is sticky only while the page's end
       (.f5-end) is within half a screen of the bottom, because Safari tints
       the bar around its address field from any sticky element at the bottom
       edge, and a footer waiting there on every screen turned that bar dark
       all the way down every page. Engaging half a screen early means the
       footer is still out of sight when it starts to wait, so the reveal
       looks exactly the same. No IntersectionObserver: no near-end class, no
       sticky, and the footer sits at the end of the page as normal. */
    var endMark = document.querySelector('.f5-end');
    if (endMark && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var near = e.isIntersecting || e.boundingClientRect.top < 0;
        document.documentElement.classList.toggle('f5-near-end', near);
      }, { rootMargin: '0px 0px 50% 0px' }).observe(endMark);
    }

    var mainEl = document.getElementById('MainContent');
    var toFooter = function () {
      if (!mainEl || !document.documentElement.classList.contains('f5-reveal')) return;
      if (mainEl.getBoundingClientRect().bottom > ftWrap.getBoundingClientRect().top + 1) {
        window.scrollTo(0, document.documentElement.scrollHeight);
      }
    };
    var hashInFooter = function () {
      try { return !!(location.hash && ftWrap.querySelector(location.hash)); } catch (err) { return false; }
    };
    ftWrap.addEventListener('focusin', toFooter);
    window.addEventListener('hashchange', function () { if (hashInFooter()) toFooter(); });
    window.addEventListener('load', function () {
      fitFooter();
      if (hashInFooter()) toFooter();
    });
  }
})();
